module.exports = __webpack_public_path__ + "static/SP_BROCHURE_1.1_logo-5e342a83b522b9a5bfae06a996560818.pdf";